const zh = {
  sidebar: {
    community: '社區&樓宇管理',
    electricLock: '電控門鎖管理',
    sipAccount: 'SIP帳戶管理',
    settings: '門禁系統配置',
    roomSip: '房間SIP帳號設置',
    staffSip: '員工SIP帳號設置',
    doorLock: '入口電控門鎖設置',
    callCenter: '呼叫中心配置',
    ecardSetting: '電子名片設置',
  },
  'Failed to fetch SIP accounts': '獲取SIP帳戶失敗',
  'Username is required': '用戶名是必填項',
  'Username must be at least 4 characters': '用戶名長度4-20個字元',
  'Password is required': '密碼是必填項',
  'Password must be at least 6 characters': '密碼長度6-8個字元',
  'SIP account deleted successfully': 'SIP帳戶刪除成功',
  'All Type': '所有類型',
  WebRTC: 'WebRTC',
  SIP: 'SIP',
  'All Status': '所有狀態',
  Online: '線上',
  Offline: '離線',
  Search: '搜索',
  'Number of Accounts': '已創建帳戶數量合計',
  Type: '類型',
  'Max Contacts': '最大設備數',
  Status: '狀態',
  'Assigned To': '分配狀態',
  Creator: '創建者',
  'Create Date': '創建日期',
  Actions: '操作',
  Assigned: '已分配',
  Unassigned: '未分配',
  Edit: '編輯',
  Delete: '刪除',
  Create: '添加',
  Update: '更新',
  Username: '用戶名',
  'Username Range': '用戶名範圍',
  Prefix: '前綴',
  From: '從',
  To: '到',
  'Prefix is required': '前綴是必填項',
  'From and To values must have the same number of digits': '從和到值必須具有相同的位數',
  'To value must be greater than From value': '到值必須大於從值',
  'SIP Domain': 'SIP伺服器IP或功能變數名稱',
  Password: '密碼',
  Category: '類別',
  Cancel: '取消',
  'Are you sure you want to delete account': '你確定要刪除帳號',
  'Delete Account': '刪除帳號',
  Account: '帳號',
  'Create Account': '添加',
  'Edit Account': '編輯帳號',
  'Number of Door Lock': '已添加門鎖數量合計',
  'Lock Management': '門鎖管理',
  Installed: '已安裝',
  Uninstalled: '未安裝',
  Refresh: '刷新',
  UUID: 'UUID',
  'Relay ID': '繼電器ID',
  'Door ID': '入口ID',
  Address: '地址',
  'Install Date': '安裝日期',
  'Lock created successfully': '門鎖添加成功',
  'Failed to create lock': '添加門鎖失敗',
  'Lock updated successfully': '門鎖更新成功',
  'Failed to update lock': '更新門鎖失敗',
  'Lock deleted successfully': '門鎖刪除成功',
  'Failed to delete lock': '刪除門鎖失敗',
  'Failed to fetch locks': '獲取門鎖失敗',
  'Are you sure you want to delete the lock "{{uuid}}"?': '確定要刪除門鎖 "{{uuid}}" 嗎？',
  'Subscription Subject *': '訂閱主題 *',
  'Publish Subject *': '發佈主題 *',
  'Wifi Name': 'Wifi名稱',
  'Wifi Password': 'Wifi密碼',
  'UUID is required': 'UUID是必填項',
  'Relay ID is required': '繼電器ID是必填項',
  'Subscription Subject is required': '訂閱主題是必填項',
  'Publish Subject is required': '發佈主題是必填項',
  All: '所有',
  'Create Lock': '添加',
  Save: '保存',
  'Edit Lock': '編輯門鎖',
  'Subscription Subject': '訂閱主題',
  'Publish Subject': '發佈主題',
  Confirm: '確認',
  'SIP account removed successfully': 'SIP帳號刪除成功',
  'All SIP': '所有SIP',
  'Assigned SIP': '已分配SIP',
  'Unassigned SIP': '未分配SIP',
  'Community Name': '社區名稱',
  'Institute Name': '機構名稱',
  'Contact Name': '連絡人姓名',
  'SIP Account': 'SIP帳號',
  Remove: '刪除',
  'Remove SIP Account': '刪除SIP帳號',
  'Are you sure you want to remove this SIP account?': '你確定要刪除這個SIP帳號嗎？',
  'Select Community': '選擇社區',
  'SIP account assigned successfully': 'SIP帳號分配成功',
  'SIP Account Setting': 'SIP帳號設置',
  'Select one from unassigned SIP List': '從SIP列表中選擇一個SIP帳號',
  'Select SIP Account': '選擇SIP帳號',
  'Select Building': '選擇樓宇',
  'All Floor': '所有樓層',
  Floor: '樓層',
  'Room No.': '房間號',
  'Building Name': '樓宇名稱',
  'Please select a SIP account': '請選擇一個SIP帳號',
  'Public Entrance': '公共入口',
  'Building Entrance': '樓宇入口',
  'Community List': '社區列表',
  'Lock UUID': '門鎖UUID',
  'WebRTC Account': 'WebRTC帳戶',
  'All Locks': '所有門鎖',
  'Lock Assigned': '門鎖已分配',
  'Lock Unassigned': '門鎖未分配',
  'WebRTC Assigned': 'WebRTC已分配',
  'WebRTC Unassigned': 'WebRTC未分配',
  'All WebRTC': '所有WebRTC',
  'Entrance Name': '入口名稱',
  'Please select a webrtc account': '請選擇一個WebRTC帳號',
  'Please select a lock': '請選擇一個門鎖',
  'Select Webrtc Account': '選擇WebRTC帳號',
  'Select Lock': '選擇門鎖',
  Setting: '設置',
  'Select one from unassigned Webrtc List': '從列表中選擇一個未分配的WebRTC帳號',
  'Select one from unassigned Lock List': '從列表中選擇一個未分配的門鎖',
  'Community deleted successfully': '社區刪除成功',
  Community: '社區',
  'Total Communities': '社區總數',
  'Total Buildings': '樓宇總數',
  'In Service': '服務中',
  'Total Rooms': '房間總數',
  Income: '收入合計',
  Active: '已啟用',
  Inactive: '未啟用',
  'Search communities...': '搜索社區...',
  '+ Create New': '添加',
  'Community ID': '社區ID',
  Room: '房間',
  'Service Time': '服務時間',
  Staff: '員工',
  'Delete Community': '刪除社區',
  'Are you sure you want to delete this community? This action cannot be undone.':
    '你確定要刪除這個社區嗎？這個操作無法撤銷。',
  Entrance: '入口',
  Building: '樓宇',
  Contract: '合同',
  'Start Service': '啟動',
  'Stop Service': '停用',
  'Delete Successfully': '刪除成功',
  'Add New': '添加新樓宇',
  Rooms: '房間',
  'Lock ID': '門鎖ID',
  'Start Time': '開始時間',
  'End Time': '結束時間',
  'Delete Building': '刪除樓宇',
  'Are you sure you want to delete this building? This action cannot be undone.':
    '你確定要刪除這個樓宇嗎？這個操作無法撤銷。',
  'Contract ID': '合同ID',
  Amount: '金額',
  Due: '到期',
  'Create New': '添加',
  'Delete Contract': '刪除合同',
  'Are you sure you want to delete this contract? This action cannot be undone.':
    '你確定要刪除這個合同嗎？這個操作無法撤銷。',
  'Please fill in all required fields': '請填寫所有必填欄位',
  'Edit Building': '編輯樓宇',
  'Create New Building': '添加',
  'Building ID': '樓宇ID',
  'Building Address': '樓宇地址',
  longitude: '經度',
  latitude: '緯度',
  'Service Range (Meters)': '服務範圍（米）',
  Contacts: '連絡人',
  'Contacts Phone': '連絡人電話',
  Email: '郵箱',
  'Edit Community': '編輯社區',
  'Create New Community': '添加',
  'Community Address': '社區地址',
  'Start date must be before end date': '開始日期必須早於結束日期',
  'Payment amount must be greater than 0': '支付金額必須大於0',
  'Contract created successfully': '合同創建成功',
  'Contract updated successfully': '合同更新成功',
  'Start Date': '開始日期',
  'End Date': '結束日期',
  'Payment Date': '支付日期',
  'Payment Amount': '支付金額',
  'Entrance updated successfully': '入口更新成功',
  'Entrance created successfully': '入口創建成功',
  'Entrance save error': '入口保存錯誤',
  'Edit Entrance': '編輯入口',
  'Create New Entrance': '添加',
  'Entrance ID': '入口ID',
  'Entrance Address': '入口地址',
  'Public service updated successfully': '社區服務更新成功',
  'Public service created successfully': '社區服務創建成功',
  'Public service save error': '社區服務保存錯誤',
  'Edit Public Service': '編輯社區服務',
  'Create New Public Service': '添加',
  'Institution Name': '機構名稱',
  'Is Public': '是否公開',
  'Not Public': '不公開',
  'Room updated successfully': '房間更新成功',
  'Room created successfully': '房間創建成功',
  'Room save error': '房間保存錯誤',
  'Edit Room': '編輯房間',
  'Create New Room': '添加',
  'Room ID': '房間ID',
  'Room Number': '房間號',
  'Entrance deleted successfully': '入口刪除成功',
  'Entrance delete error': '入口刪除錯誤',
  'Delete Entrance': '刪除入口',
  'Are you sure you want to delete this entrance? This action cannot be undone.':
    '你確定要刪除這個入口嗎？這個操作無法撤銷。',
  'Select Location': '選擇位置',
  'Public Service': '社區服務',
  'Public service deleted successfully': '社區服務刪除成功',
  'Public service delete error': '社區服務刪除錯誤',
  'Delete Public Service': '刪除社區服務',
  'Are you sure you want to delete this public service? This action cannot be undone.':
    '你確定要刪除這個社區服務嗎？這個操作無法撤銷。',
  'Select Floor': '選擇樓層',
  'All Floors': '所有樓層',
  'Room No': '房間號',
  'Delete Room': '刪除房間',
  'Are you sure you want to delete this room? This action cannot be undone.':
    '你確定要刪除這個房間嗎？這個操作無法撤銷。',
  'End Service': '停用',
  'Service Time Error': '服務時間錯誤',
  Longitude: '經度',
  Latitude: '緯度',
  Download: '下載',
  'Entrance QR Code': '公共入口二維碼',
  'Building QR Code': '樓宇入口二維碼',
  'all building': '所有樓宇',
  'Invalid URL parameters': '無效的URL參數',
  'Call To': '呼叫',
  'Hang up': '掛斷',
  'Please connect to the network': '請連接網絡',
  'Call in progress': '通話進行中',
  'Call failed': '呼叫失敗',
  'Call connected': '呼叫連接',
  'Call Room': '呼叫房間',
  'Are you sure you want to call this number room?': '你確定要呼叫這個{{number}}房間嗎？',
  Call: '呼叫',
  'Checking microphone access...': '檢查麥克風訪問...',
  'Checking microphone...': '檢查麥克風...',
  'Please allow microphone access': '請允許麥克風訪問',
  'Microphone not found': '麥克風未找到',
  'Cannot access your microphone': '無法訪問您的麥克風',
  'Detecting your location...': '偵測您的位置...',
  'Verifying your location...': '驗證您的位置...',
  'Getting location...': '獲取位置...',
  'verifying location...': '驗證位置...',
  'Please allow location access': '請允許位置訪問',
  'Location verified': '位置驗證',
  'Exceeding the service distance': '超出服務距離',
  'Error checking location': '位置檢查錯誤',
  'Request Permission': '請求許可',
  'Request Open Door': '訪客指引',
  'Connecting...': '連接中...',
  Connected: '已連接',
  Disconnected: '已斷開',
  Ready: '已準備就緒',
  'Registration Failed': '註冊失敗',
  'Calling...': '呼叫中...',
  Service: '服務',
  User: '用戶',
  lat: '緯度',
  long: '經度',
  'Door Name': '入口名稱',
  'Transfer Name': '轉帳名稱',
  'Transfer Address': '傳輸地址',
  'Transfer Password': '轉移密碼',
  roomNumber: '房间号',
  'If location and microphone usage permissions have not been granted, please refresh the page and re authorize!':
    '如果未授予位置和麥克風使用權限，請刷新頁面重新授權！',
  'Refresh page': '刷新頁面',
  'Call ends in': '剩餘通話時長:',
  'Call ended due to timeout': '通話因超時而結束',
  'Call ended': '呼叫結束',
  bulk_create: '批量新增',
  'Bulk Create Account': '批量新增',
  'Successfully created count_SIP accounts': '成功創建 {{count_SIP}} 個SIP賬號',
  voice_call: '語音通話',
  video_call: '視頻通話',
  'Please input all required fields': '請輸入所有必填字段',
  'Please input valid domain': '請輸入有效的域名格式',
  'Please save the call center first': '請先保存呼叫中心',
  'Please select a category first': '請先選擇一個類別',
  'Call Center Name': '呼叫中心名稱',
  Agent: '代理',
  'Search call centers...': '搜尋呼叫中心...',
  URL: '網址',
  'Access Domain Name': '網域名稱',
  'Category List': '分類清單',
  'Agent List': '代理列表',
  No: '編號',
  'No result': '暫無資料',
  'Assigned Sip List': '已分配SIP清單',
  Duty: '職務',
  isPublic: '公開',
  Avatar: '頭像',
  'Click to upload image': '點擊上傳圖片',
  'Click to upload file': '點擊上傳檔案',
  Name: '姓名',
  Gender: '性別',
  email: '信箱',
  'Sip Account': 'SIP帳號',
  category_name: '分類名稱',
  'Agent Info': '代理資訊',
  Male: '男',
  Female: '女',
  Yes: '是',
  no: '否',
  Preview: '預覽',
  QRCode: '二維碼',
  male: '男',
  female: '女',
  'Save Successfully': '保存成功',
  'Update Successfully': '更新成功',
  'Call Center QR Code': '呼叫中心二維碼',
  'Customer Service': '客戶服務',
  'Search agents...': '搜尋代理...',
  'Select a category': '選擇一個分類',
  'No agents available': '暫無代理',
  'Voice Call': '語音通話',
  'Video Call': '視頻通話',
  'Call Agent': '呼叫代理',
  'Are you sure you want to call': '你確定要呼叫',
  'Please wait for connection to be established': '請等待連接建立',
  'Failed to load call center data': '無法載入呼叫中心資料',
  'Error checking microphone': '麥克風檢查錯誤',
  'Please allow camera and microphone access to make video calls':
    '請允許攝像頭和麥克風訪問以進行視頻通話',
  'Please allow microphone access to make voice calls': '請允許麥克風訪問以進行語音通話',
  'Camera or microphone not found': '未找到攝像頭或麥克風',
  'Unable to access media devices': '無法訪問媒體設備',
  'Call rejected or busy': '呼叫被拒絕或忙線',
  'The agent is busy or rejected the call': '代理忙線或拒絕了呼叫',
  'Agent not found': '未找到代理',
  'The agent could not be reached': '無法聯繫到代理',
  'Call timeout': '呼叫超時',
  'The agent did not answer': '代理未接聽',
  'Service unavailable': '服務不可用',
  'Call service is currently unavailable': '呼叫服務目前不可用',
  'Call failed. Please try again.': '呼叫失敗，請重試',
  'Call was rejected': '呼叫被拒絕',
  'Call ended by remote party': '對方已結束通話',
  'Call ended due to connection error': '通話因連接錯誤而結束',
  'Connection error occurred': '連接錯誤',
  'Connection lost': '連接丟失',
  'Network connection lost': '網絡連接丟失',
  'Connection closed': '連接已關閉',
  'Connection failed': '連接失敗',
  'Call connection failed': '通話連接失敗',
  'Failed to play remote video': '無法播放遠程視頻',
  'Failed to play audio': '無法播放音頻',
  'This category has agents assigned to it. Are you sure you want to delete it? All agents will be deleted from this category.':
    '這個分類有代理分配给它。你確定要刪除它嗎？所有代理將從該分類中刪除。',
  'Delete Category': '删除分类',
  'Are you sure you want to delete this category? This action cannot be undone.':
    '你確定要刪除這個分類嗎？這個操作無法撤銷。',
  'Delete Call Center': '删除呼叫中心',
  'Are you sure you want to delete this call center? This action cannot be undone.':
    '你確定要刪除這個呼叫中心嗎？這個操作無法撤銷。',
  'This call center has categories assigned to it. Are you sure you want to delete it? All categories will be deleted from this call center.':
    '這個呼叫中心有分類分配给它。你确定要删除它吗？所有分類将从该呼叫中心中删除。',
  'Delete Agent': '刪除代理',
  'Are you sure you want to delete this agent? This action cannot be undone.':
    '你確定要刪除這個代理嗎？這個操作無法撤銷。',
  ECard: '電子名片',
  'ECard Info': '電子名片信息',
  'Delete ECard': '刪除電子名片',
  'Are you sure you want to delete this ECard? This action cannot be undone.':
    '你確定要刪除這個電子名片嗎？這個操作無法撤銷。',
  'ECard QR Code': '電子名片二維碼',
  'Search ECards...': '搜尋電子名片...',
  'This ecard is not public. Please contact the administrator to get the public ecard.':
    '這個電子名片不是公開的。請聯繫管理員獲取公開的電子名片。',
  Department: '部門',
  Copy: '複製',
  'Copied to clipboard': '已複製到剪貼板',
  'Initiate Call': '發起呼叫',
  ConfirmCall: '確定',
  'Optimizing Network' : '網絡優化中...',
  'Are you sure you want to call this number?': '你確定要呼叫{{number}}嗎？',
  'ECard Loading...': '電子名片加載中...',
};
export default zh;
